export const automationEn = {
  title: "Automations",
  read_only:
    "Read only: this is what happens automatically after each outcome.",
  tabs: { rules: "Rules", history: "History" },
  new_rule: "New rule",
  enable: "Enable %{name}",
  move_up: "Move %{name} up",
  move_down: "Move %{name} down",
  none: "No rules.",
  columns: {
    name: "Name",
    trigger: "Trigger",
    last_run: "Last run",
    runs: "Runs (7 d)",
    failures: "Failures (7 d)",
    status: "Status",
    error: "Error code",
    date: "Date",
    details: "Details",
    enabled: "Enabled",
    order: "Order",
  },
  triggers: {
    call_outcome: "Call outcome",
    deal_stage_changed: "Deal stage changed",
    deal_created: "Deal created",
    no_activity: "No activity",
    email_event: "Email event",
    meeting_note_matched: "Meeting notes matched",
    schedule: "Schedule",
  },
  statuses: {
    done: "Done",
    failed: "Failed",
    skipped: "Skipped",
    running: "Running",
    scheduled: "Scheduled",
    cancelled: "Cancelled",
    planned: "Planned",
  },
  field_groups: {
    call: "Call",
    company: "Company",
    rep: "Rep",
    deal: "Deal",
    email: "Email",
    meeting: "Meeting",
    event: "Event",
  },
  editor: {
    title_new: "New rule",
    name: "Name",
    description: "Description",
    trigger: "Trigger",
    conditions: "Conditions",
    actions: "Actions",
    group_mode: "Group mode",
    all: "All conditions",
    any: "Any condition",
    add_condition: "Add condition",
    add_group: "Add group",
    condition_n: "Condition %{n}",
    group_n: "Group %{n}",
    remove_condition: "Remove condition %{n}",
    remove_group: "Remove group %{n}",
    field: "Field",
    op: "Operator",
    value: "Value",
    value_list_hint: "Comma-separated values",
    action_n: "Action %{n}",
    remove_action: "Remove action %{n}",
    move_action_up: "Move action %{n} up",
    move_action_down: "Move action %{n} down",
    add_action: "Add action",
    action_type: "Action type",
    save: "Save",
    saved: "Rule saved.",
    deleted: "Rule deleted.",
    delete: "Delete rule",
    close: "Close",
    test: "Test the rule",
    no_activity_days: "Days without activity",
    no_activity_entity: "Entity",
    stages: "Stages",
    cron: "Cron expression",
    trigger_reset_confirm:
      "Switching to “%{trigger}” clears the current conditions. Continue?",
    trigger_reset_ok: "Change trigger",
    cancel: "Cancel",
  },
  params: {
    business_days: "Business days",
    at: "Time",
    status: "Status",
    days: "Days",
    task_type: "Task type",
    text: "Text",
    due: "Due",
    assignee: "Assignee",
    stage: "Stage",
    name_template: "Name template",
    amount_from: "Amount from",
    text_template: "Text template",
    sequence_id: "Sequence (id)",
    reason: "Reason",
    template: "Template",
    via: "Send via",
    to: "Recipient",
    from: "Source",
    who: "Recipient",
    message_template: "Message template",
    channels: "Channels",
    trigger: "Moment",
  },
  delay: {
    label: "When",
    now: "Immediately",
    business_days: "In N business days at HH:MM",
    minutes: "In N minutes",
    hours: "In N hours",
    before: "N hours before the demo",
    from: "At the callback time",
    n: "N",
    at: "Time",
  },
  ops: {
    eq: "is",
    neq: "is not",
    in: "is one of",
    nin: "is not one of",
    gt: ">",
    gte: "≥",
    lt: "<",
    lte: "≤",
    exists: "exists",
    not_exists: "does not exist",
    contains: "contains",
    days_since_gte: "at least N days ago",
    matches: "matches",
  },
  actions: {
    set_callback: "Schedule a callback",
    set_prospect_status: "Change status",
    cool_down: "Cool down",
    create_task: "Create a task",
    create_deal: "Create a deal",
    move_deal: "Change deal stage",
    add_note: "Add a note",
    enroll_sequence: "Enroll in a sequence",
    stop_sequences: "Stop sequences",
    send_email: "Send an email",
    create_calendar_event: "Create an Outlook event",
    notify_teams: "Post in Teams",
    notify_user: "Notify a user",
    suppress: "Add to the do-not-contact list",
    ai_draft: "Prepare an AI draft",
  },
  dry_run: {
    title: "Dry run",
    event: "Event",
    pick: "Pick a recent event",
    matched: "Conditions matched",
    not_matched: "Conditions not matched",
    trace: "Evaluated conditions",
    nothing: "No action",
    skipped: "skipped (%{reason})",
    due: "due on %{date}",
    none_events: "No recent event for this trigger.",
    no_write: "Nothing is saved or executed.",
  },
  issue_at: {
    action: "Action %{n}",
    conditions: "Conditions",
    rule: "Rule",
  },
  errors: {
    required: "Required field.",
    name_required: "Name is required.",
    invalid_rule: "Invalid rule.",
    conditions_required: "Conditions are required ({} means “always”).",
    too_deep: "Two group levels at most.",
    unknown_op: "Unknown operator.",
    invalid_regex: "Invalid regular expression.",
    unsafe_regex:
      "Unsafe regular expression (nested quantifiers). Simplify it.",
    actions_not_array: "The action list is invalid.",
    unknown_action: "Unknown action.",
    invalid_business_days:
      "Business days must be a whole number between 0 and 366.",
    unknown_template: "Unknown email template.",
    save_failed: "Could not save the rule.",
  },
  warnings: {
    unknown_field: "Unknown field for this trigger.",
    prefer_graph: "Prefer Graph for one-to-one emails.",
  },
  history: {
    filter_rule: "Rule",
    filter_status: "Status",
    all: "All",
    none: "No runs.",
    hide: "Hide",
  },
};
